/* import __COLOCATED_TEMPLATE__ from './conversation-attachments.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import type AppService from 'embercom/services/app-service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import type AttachmentSettings from 'embercom/models/attachment-settings';
import { inject as service } from '@ember/service';
import { cached } from 'tracked-toolbox';

export class PredicateGroupProxy {
  private settings: $TSFixMe;
  private onChange: () => void;

  constructor(settings: $TSFixMe, onChange: () => void) {
    this.settings = settings;
    this.onChange = onChange;
  }

  get predicates() {
    let arr: $TSFixMe = [...(this.settings?.fileUploadAudiencePredicates ?? [])];
    arr.serialize = () =>
      arr.map((p: $TSFixMe) => (typeof p?.serialize === 'function' ? p.serialize() : p));
    return arr;
  }

  set predicates(value: $TSFixMe) {
    this.settings.set('fileUploadAudiencePredicates', value);
    this.onChange();
  }

  get editablePredicates() {
    return this.predicates;
  }
}

interface Args {
  attachmentSettings: AttachmentSettings;
  settings: $TSFixMe;
  toggleUserAttachmentSettingsEnabled: () => void;
  onPredicatesChanged: () => void;
}

interface Signature {
  Args: Args;
}

export default class ConversationAttachments extends Component<Signature> {
  @tracked showRiskConfirmation = false;
  @service declare appService: AppService;
  @service declare attributeService: $TSFixMe;

  @cached
  get predicateGroup() {
    return new PredicateGroupProxy(this.args.settings, () => this.args.onPredicatesChanged());
  }

  get userAttributes() {
    return this.attributeService.attributeGroupListForUsers;
  }

  @action
  toggleOtherFiles() {
    if (!this.args.attachmentSettings.allowedAttachmentFiletypesEnabled) {
      this.openOtherFilesModal();
    } else {
      this.args.attachmentSettings.set('allowedAttachmentFiletypesEnabled', false);
      this.args.attachmentSettings.set('allowedAttachmentFiletypesAgreedToRisk', false);
      this.args.attachmentSettings.set('allowedAttachmentFiletypesList', '');
    }
  }

  @action
  enableOtherFiles() {
    this.args.attachmentSettings.set('allowedAttachmentFiletypesEnabled', true);
    this.args.attachmentSettings.set('allowedAttachmentFiletypesAgreedToRisk', true);
    this.closeOtherFilesWarningModal();
  }

  @action
  openOtherFilesModal() {
    this.showRiskConfirmation = true;
  }

  @action
  cancelOtherFiles() {
    this.args.attachmentSettings.set('allowedAttachmentFiletypesEnabled', false);
    this.args.attachmentSettings.set('allowedAttachmentFiletypesAgreedToRisk', false);
    this.closeOtherFilesWarningModal();
  }

  @action
  closeOtherFilesWarningModal() {
    this.showRiskConfirmation = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Security::Tabs::ConversationAttachments': typeof ConversationAttachments;
    'new-settings/workspace/security/tabs/conversation-attachments': typeof ConversationAttachments;
  }
}
